export default "<div class=\"service_icon\" [ngClass]=\"{'icon-gray': !subscribed, 'icon-green': subscribed}\" >\n  <img [src]='serviceImage'/>\n</div>\n";